// Normalize supported localized digits only at explicit numeric input boundaries.
// Preserve separators, signs and every other character for the caller's parser.
// This does not validate dates, parse money or alter user-authored message text.
export function normalizeInputDigits(input: string, language: string): string {
  return language === 'bn'
    ? input.replace(/[০-৯]/g, digit => String(digit.charCodeAt(0) - '০'.charCodeAt(0)))
    : input;
}
